<acl-ngx-accordion title="Inventory Source" [open]="true">
  <ng-template #inventorySource>
    <div class="inventory-allocation">
      <div class="inv-allocation-header">
        <h6>Inventory Source</h6>
        <div class="inventory-allocation-header-content row">
          <div class="header-description col-11">
            <p class="text-description">
              Plan summary only include inventory sources that get allocated budget. If you want to change your plan
              set-up or add and specific rules on budget allocation to specific inventory source/deal, please clicks
              "Edit
              Plan".
            </p>
          </div>
          <!--Export Button-->
          <div class="export-icon-btn col-1">
            <acl-ngx-icon title="Export" [name]="'Download'" (click)="exportAllocationData()">
            </acl-ngx-icon>
          </div>
        </div>
      </div>

      <!-- <div class="inventory-allocation-dropdown">
    <select class="form-control-sm" (change)="renderInventoryAllocationView($event)">
      <option [ngValue]="item.key" *ngFor="let item of inventoryAllocationTypes | keyvalue"
        [selected]="item.value.name === isSelected">
        {{item.value.name}}
      </option>
    </select>
  </div> -->

      <!--Budget Allocation Content-->
      <div class="inv-src-data-table">
        <table class="table table-bordered">
          <!--table headers-->
          <thead>
            <tr>
              <th class="accordion-icon-col"></th>
              <th class="name-col" scope="col">Name</th>
              <th scope="col">Deal ID</th>
              <th class="text-right" scope="col">Allocated</th>
              <th class="text-right" scope="col">Estimated IMP</th>
              <th class="text-right" scope="col">Estimated CPM</th>
            </tr>
          </thead>
          <tbody>
            <!--Inventory Source Totals-->
            <ng-container *ngIf="total">
              <tr class="dark-header">
                <td [attr.colspan]="2" class="border-0">{{total.name}}</td>
                <!-- <td class="border-0"></td> -->
                <td class="border-0"></td>
                <td class="border-0 text-right">{{total.allocatedBudget | currency :
                  planDetails.currency : 'symbol' : '1.0-2'}}</td>
                <td class="border-0 text-right">{{total.allocatedImpressions | number : '1.0-0'}}</td>
                <td class="border-0 text-right">{{total.averageCPM | currency :
                  planDetails.currency : 'symbol' : '1.0-2'}}</td>
              </tr>
            </ng-container>
            <!--Open Auctions-->
            <ng-container *ngIf="openAuction">
              <!--Open Auctions Totals-->
              <tr class="collapsed totals-row" data-toggle="collapse" data-target="#exchanges"
                (click)="showExchanges = !showExchanges">
                <td class="contain-col-content  accordion-icon border-right-0">
                  <acl-ngx-icon name="TriangleRight" size="12" *ngIf="showExchanges">
                  </acl-ngx-icon>
                  <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!showExchanges">
                  </acl-ngx-icon>
                </td>
                <td class="border-left-0">{{openAuction.total.name}}</td>
                <td class="contain-col-content"></td>
                <td class="contain-col-content text-right">{{openAuction.total.allocatedBudget | currency :
                  planDetails.currency : 'symbol' : '1.0-2'}}</td>
                <td class="text-right">{{openAuction.total.allocatedImpressions | number : '1.0-0'}}</td>
                <td class="text-right">{{openAuction.total.averageCPM | currency : planDetails.currency : 'symbol'
                  : '1.0-2'}}</td>
              </tr>
              <!--Open Exchanges Results-->
              <ng-container *ngIf="openAuction?.results">
                <tr *ngFor="let item of openAuction.results; let i=index" [ngbCollapse]="showExchanges" id="exchanges"
                  class="collapse">
                  <td class="border-right-0"></td>
                  <td class="contain-col-content border-left-0" [title]="item.name">{{item.name}}</td>
                  <td class="contain-col-content"> - </td>
                  <td class="text-right">
                    {{item.allocatedBudget | currency : planDetails.currency : 'symbol' : '1.0-2'}}
                  </td>
                  <td class="text-right">
                    {{item.allocatedImpressions | number : '1.0-0'}}
                  </td>
                  <td class="text-right">
                    {{item.averageCPM | currency : planDetails.currency : 'symbol' : '1.0-2'}}
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <!--Private Deals-->
            <ng-container *ngIf="privateDeals">
              <!--Private Deals Totals-->
              <tr class="collapsed totals-row" data-toggle="collapse" data-target="#privateDeals"
                (click)="showPrivateDeals = !showPrivateDeals">
                <td class="contain-col-content border-right-0">
                  <acl-ngx-icon name="TriangleRight" size="12" *ngIf="showPrivateDeals">
                  </acl-ngx-icon>
                  <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!showPrivateDeals">
                  </acl-ngx-icon>
                </td>
                <td class="border-left-0">{{privateDeals.total.name}}</td>
                <td class="contain-col-content"></td>
                <td class="contain-col-content text-right">{{privateDeals.total.allocatedBudget | currency :
                  planDetails.currency : 'symbol' : '1.0-2'}}</td>
                <td class="text-right">{{privateDeals.total.allocatedImpressions | number : '1.0-0'}}</td>
                <td class="text-right">{{privateDeals.total.averageCPM | currency :
                  planDetails.currency : 'symbol' : '1.0-2'}}</td>
              </tr>
              <!--Private deal Results-->
              <ng-container *ngIf="privateDeals">
                <ng-container *ngFor="let item of privateDeals.results; let i = index">
                  <tr data-toggle="collapse" [ngbCollapse]="showPrivateDeals" id="privateDeals" class="collapse"
                    data-target="#deals" (click)="item.isCollapsed = !item.isCollapsed">
                    <td class="contain-col-content border-right-0"></td>
                    <td class="border-left-0">
                      <span class="sub-accordion">
                        <acl-ngx-icon name="TriangleRight" size="12" *ngIf="item.isCollapsed">
                        </acl-ngx-icon>
                        <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!item.isCollapsed">
                        </acl-ngx-icon>
                      </span>
                      <span [title]="item.total.name">{{item.total.name}}</span>
                    </td>
                    <td class="contain-col-content">{{item.total.dealId}}</td>
                    <td class="contain-col-content text-right">
                      {{item.total.allocatedBudget | currency :
                      planDetails.currency : 'symbol' : '1.0-2'}}
                    </td>
                    <td class="text-right">
                      {{item.total.allocatedImpressions | number : '1.0-0'}}
                    </td>
                    <td class="text-right">
                      {{item.total.averageCPM | currency :
                      planDetails.currency : 'symbol' : '1.0-2'}}
                    </td>
                  </tr>
                  <ng-container>
                    <tr *ngFor="let j of item.results" class="collapse"
                      [ngbCollapse]="item.isCollapsed || showPrivateDeals" id="privateDeals" class="collapse">
                      <td class="border-right-0"></td>
                      <td class="contain-col-content padding-left-35 border-left-0" [title]="j.name">
                        <span>{{j.name}}</span>
                        <span *ngIf="j.isAmobeePreferred" class="amobee-preferred-info-icon margin-left-15">
                          <acl-ngx-icon name="Info" title="This is an Amobee Preferred Deal" size="16">
                          </acl-ngx-icon>
                        </span>
                      </td>
                      <td class="contain-col-content">{{j.dealId}}</td>
                      <td class="text-right"> - </td>
                      <td class="text-right"> - </td>
                      <td class="text-right"> - </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <!--Guaranteed Deals-->
            <!-- <ng-container> -->
            <!--Guaranteed Deals Totals-->
            <!-- <tr class="collapsed totals-row" data-toggle="collapse" data-target="#guaranteedDealsAcc"
                (click)="guaranteedDealsAcc = !guaranteedDealsAcc">
                <td class="contain-col-content border-right-0">
                  <acl-ngx-icon name="TriangleRight" size="12" *ngIf="guaranteedDealsAcc">
                  </acl-ngx-icon>
                  <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!guaranteedDealsAcc">
                  </acl-ngx-icon>
                </td>
                <td class="border-left-0">Guaranteed Deals</td>
                <td class="contain-col-content"></td>
                <td class="contain-col-content text-right">
                  {{guaranteedDeals.total.allocatedBudget | currency : planDetails.currency : 'symbol' : '1.0-0'}}
                </td>
                <td class="text-right">
                  {{guaranteedDeals.total.allocatedImpressions | number : '1.0-0'}}
                </td>
                <td class="text-right">
                  {{guaranteedDeals.total.averageCPM | currency : planDetails.currency : 'symbol' : '1.0-0'}}
                </td>
              </tr> -->
            <!--Gauranteed Deals Results-->
            <!-- <ng-container>
                <tr *ngFor="let item of guaranteedDeals.results" [ngbCollapse]="guaranteedDealsAcc"
                  id="guaranteedDealsAcc" class="collapse">
                  <td class="border-right-0"></td>
                  <td class="contain-col-content border-left-0">{{item.name}}</td>
                  <td class="contain-col-content">{{item.dealId}}</td>
                  <td class="text-right">
                    {{item.allocatedBudget | currency : planDetails.currency : 'symbol' : '1.0-0'}}
                  </td>
                  <td class="text-right">
                    {{item.allocatedImpressions | number : '1.0-0'}}
                  </td>
                  <td class="text-right">
                    {{item.averageCPM | currency : planDetails.currency : 'symbol' : '1.0-0'}}
                  </td>
                </tr>
              </ng-container> -->
            <!-- </ng-container> -->
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>

  <acl-ngx-card [renderBody]="inventorySource"></acl-ngx-card>
</acl-ngx-accordion>
